var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType2DarkDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 72,
    viewBox: "0 0 48 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 68V58.2344H9.15625V56.7266H0.382812V58.2344H3.89844V68H5.64844ZM10.4219 71.0859C12.1562 71.0859 12.9609 70.4297 13.6875 68.3906L16.8672 59.5156H15.0859L12.9062 66.4531H12.8672L10.6875 59.5156H8.86719L11.9453 68.0234L11.8125 68.4609C11.5234 69.3594 11.0781 69.7031 10.2734 69.7031C10.125 69.7031 9.85938 69.6953 9.73438 69.6641V71.0391C9.86719 71.0625 10.2812 71.0859 10.4219 71.0859ZM22.2734 59.4297C21.0938 59.4297 20.0469 60.0078 19.5703 60.9219H19.5312V59.5156H17.8984V70.8125H19.5938V66.6094H19.625C20.1328 67.5469 21.0938 68.0859 22.3125 68.0859C24.4453 68.0859 25.8594 66.3828 25.8594 63.7578C25.8594 61.125 24.4375 59.4297 22.2734 59.4297ZM21.8438 66.6484C20.4922 66.6484 19.5859 65.4922 19.5781 63.7578C19.5859 62.0312 20.5 60.8672 21.8438 60.8672C23.2188 60.8672 24.125 62.0078 24.125 63.7578C24.125 65.5156 23.2188 66.6484 21.8438 66.6484ZM30.7422 60.7891C31.9766 60.7891 32.8125 61.6641 32.8516 62.9844H28.5469C28.6406 61.6797 29.5234 60.7891 30.7422 60.7891ZM32.8438 65.5156C32.6094 66.2578 31.8359 66.7266 30.8516 66.7266C29.4609 66.7266 28.5391 65.7578 28.5391 64.2891V64.1875H34.5469V63.5938C34.5469 61.0234 33.0781 59.4062 30.75 59.4062C28.375 59.4062 26.8281 61.1328 26.8281 63.7891C26.8281 66.4453 28.3594 68.1016 30.8203 68.1016C32.7266 68.1016 34.2188 67.0391 34.4609 65.5156H32.8438ZM39.5156 60.0312V60.0469H41.1719V60.0234C41.1719 58.8516 42.1016 57.9609 43.3359 57.9609C44.5078 57.9609 45.4141 58.7578 45.4141 59.7578C45.4141 60.6406 45.0547 61.2344 43.6797 62.6641L39.6094 66.8125V68H47.3203V66.5234H41.9688V66.4844L44.7891 63.6484C46.4375 61.9609 47.1406 60.9844 47.1406 59.6719C47.1406 57.8828 45.5391 56.5156 43.3906 56.5156C41.1484 56.5156 39.5156 58 39.5156 60.0312Z",
    fill: "#5A5A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58853 3C3.33666 7.36604 0 13.904 0 21.2203C0 34.3555 10.7506 45 24 45C37.2568 45 48 34.3555 48 21.2203C48.0075 13.904 44.6708 7.36604 39.4189 3M8.58853 3V4H8.95423M8.58853 3H39.4189M8.58853 3L9.2278 3.76898C9.136 3.8453 9.0448 3.92231 8.95423 4M8.95423 4C4.07736 8.18336 1 14.3438 1 21.2203C1 33.7943 11.294 44 24 44C36.7133 44 47 33.7945 47 21.2203V21.2192C47.007 14.3435 43.9301 8.18338 39.0532 4M8.95423 4H39.0532M39.0532 4H39.4189V3M39.0532 4C38.9627 3.92231 38.8715 3.8453 38.7797 3.76898L39.4189 3",
    stroke: "#5A5A5E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.75C20 14.2688 18.7688 15.5 17.25 15.5C15.7312 15.5 14.5 14.2688 14.5 12.75C14.5 11.2312 15.7312 10 17.25 10C18.7688 10 20 11.2312 20 12.75Z",
    stroke: "#5A5A5E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.5C14 24.433 12.433 26 10.5 26C8.567 26 7 24.433 7 22.5C7 20.567 8.567 19 10.5 19C12.433 19 14 20.567 14 22.5Z",
    stroke: "#5A5A5E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 33C21.5 34.933 19.933 36.5 18 36.5C16.067 36.5 14.5 34.933 14.5 33C14.5 31.067 16.067 29.5 18 29.5C19.933 29.5 21.5 31.067 21.5 33Z",
    stroke: "#5A5A5E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 22.5C27.5 24.433 25.933 26 24 26C22.067 26 20.5 24.433 20.5 22.5C20.5 20.567 22.067 19 24 19C25.933 19 27.5 20.567 27.5 22.5Z",
    stroke: "#5A5A5E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33C35 34.933 33.433 36.5 31.5 36.5C29.567 36.5 28 34.933 28 33C28 31.067 29.567 29.5 31.5 29.5C33.433 29.5 35 31.067 35 33Z",
    stroke: "#5A5A5E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41 22.5C41 24.433 39.433 26 37.5 26C35.567 26 34 24.433 34 22.5C34 20.567 35.567 19 37.5 19C39.433 19 41 20.567 41 22.5Z",
    stroke: "#5A5A5E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 12.75C33.5 14.2688 32.2688 15.5 30.75 15.5C29.2312 15.5 28 14.2688 28 12.75C28 11.2312 29.2312 10 30.75 10C32.2688 10 33.5 11.2312 33.5 12.75Z",
    stroke: "#5A5A5E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2DarkDisabled);
export default __webpack_public_path__ + "static/media/type2_dark_disabled.11bbf663466808128742b17119f1558f.svg";
export { ForwardRef as ReactComponent };